import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from '@fortawesome/free-solid-svg-icons';

export const loadIcons = () => library.add(
  icons.faCheck,
  icons.faChevronUp,
  icons.faChevronDown,
  icons.faEdit,
  icons.faExternalLinkAlt,
  icons.faFile,
  icons.faImage,
  icons.faImages,
  icons.faMobileAlt,
  icons.faPlus,
  icons.faShoppingCart,
  icons.faSync,
  icons.faTag,
  icons.faTimes,
  icons.faTrashAlt,
  icons.faUpload,
);
